import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { FlamingoRetryInterceptor } from './flamingo-retry.interceptor';
import { FlamingoSelectInterceptor } from './flamingo-select.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: FlamingoRetryInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: FlamingoSelectInterceptor, multi: true },
];
